import React from "react";
import Lottie from "react-lottie";
import { defaultOption } from "../defaultOption";
import animationData from "../../../lottieData/Home/home-tab-simplification.json";

export default function HomeTabSnRLottie() {
  return (
    <Lottie
      options={defaultOption(animationData)}
      width={400}
      isStopped={false}
      isPaused={false}
    />
  );
}
